/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Hjem',
	homePageTabsLabel: 'Innhold i Hjem',
	myContent: 'Mitt innhold',
	teamContent: 'Gruppeinnhold',
	folder: '\t\t\t\t Mappe',
	files: 'Filer',
	actionMenu: 'Handlingsmeny',
	myFolder: 'Mine mapper',

	emptyFolderNoContent: 'Ikke noe innhold',

	//EmptyStates
	emptyRecentTitle: 'Du har ikke vist noe innhold nylig.',
	emptyStateTitle: 'Begynn ved å legge til data',
	emptyStateBody: 'Klikk på Last opp data ovenfor eller dra og slipp for å laste opp data.',
	emptySearchResultTitle: 'Søket ditt returnerte ingen resultater.',
	emptyPortalTitle: 'Ingen portaler',
	emptyPortalBody: 'Du har i øyeblikket ingen portaler.',
	emptyWsProjectTitle: 'Begynn ved å opprette en notisbok i Watson Studio.',
	emptyWsProjectBody: 'Når du kommer tilbake til Cognos Analytics, vil notisboken bli vist her.',
	emptyFilteredResultTitle: 'Filtrene du brukte, returnerte ingen resultater.',
	emptyDialogViewTitle: 'Ingen elementer',
	removeFromRecents: 'Fjern fra nyeste',

	// Welcome Banner
	welcomeBannerGreeting: 'Hei. Velkommen til Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson gir brukere mer makt med AI-drevne selvbetjeningsanalyser. Se hvordan automatiserte dataforberedelser, datafunn og visualiseringer kan generere mer selvsikre beslutninger.',
	welcomeBannerDescription_trialUser: 'Du kan komme i gang med en gang ved å ta en titt på introduksjonsvideoen vår, produktomvisningen og flippen Komme i gang.',
	takeTourButtonLabel: 'Få en produktrundtur',
	watchVideoButtonLabel: 'Se video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Er du sikker på at du vil slå av velkomstbanneret på hjemmesiden din? Du kan når som helst slå det på igjen i Profil og innstillinger > Innstillinger > Generelt. ',
	hideWelcomeBannerTitle: 'Slå av velkomstbanner',
	ok: 'OK',
	cancel: 'Avbryt',
	warn: 'Advarsel',
	//howto video dialog
	modal_how_title: 'Se Cognos Analytics-oversikt',
	modal_overview_title: 'Se Cognos Analytics-oversikt',
	modal_how_play: 'Spill av video',
	modal_how_video_title_overview: 'Oversikt',
	modal_how_video_title_getStarted: 'Komme i gang i 11.2',
	modal_how_video_title_newUI: 'Velkommen til den nye Cognos-opplevelsen',
	modal_how_video_title_dataModule: 'Oversikt over datamoduler',
	modal_how_video_title_explore: 'Oversikt over datautforsking',
	modal_how_video_title_dashboard: 'Oversikt over interaktive dashbord',
	modal_how_video_title_reporting: 'Oversikt over rapportering',
	modal_how_video_title_mobile: 'Kraften fra Cognos i håndflaten din',

	// Toolbar
	search: 'Søk',
	addFolder: 'Legg til mappe',
	addLink: 'Legg til link',
	filter: 'Filtrer',
	sort: 'Sorter',
	settings: 'Innstillinger',
	tilesView: 'Flisevisning',
	listView: 'Listevisning',
	columnView: 'Kolonnevisning',
	backToSearch: 'Tilbake til søkeresultat',

	// Toolbar Actions
	sortBy: 'Sorter etter',
	sortOrder: 'Sorter',
	name: 'Navn',
	modifiedTime: 'Endret',
	type: 'Type',
	ascending: 'Stigende',
	descending: 'Synkende',
	resetSort: 'Tilbakestill sortering',

	filterType: 'Type',
	filterModificationTime: 'Endret',
	all: 'Alle',
	today: 'I dag',
	yesterday: 'I går',
	pastWeek: 'Siste uke',
	pastMonth: 'Siste måned',
	resetFilters: 'Tilbakestill filtre',
	resultLimit: 'Resultatgrense',

	filterSearchPlaceHolder: 'Filtrer etter nøkkelord',

	resetFilterTag: 'Klikk på X for å tilbakestille filtre.',
	filterTagToolTip: 'Filtre brukt: %{appliedFilters}.',

	folderName: 'Mappenavn',
	addAFolder: 'Legg til en mappe',
	add: 'Legg til',
	error: 'Feil',
	newFolderDefaultName: 'Ny mappe',
	toastCreateNewFolder: '%{nameOfFolder}-mappe ble opprettet i %{tabName}.',
	folderAdded: 'Mappe lagt til',
	refresh: 'Oppdater',
	openFolder: 'Åpne mappe',

	addAUrl: 'Legg til en URL',
	linkName: 'URL-navn',
	linkNamePlaceholder: 'Legg til URL-navn',
	linkDescription: 'Beskrivelse (valgfritt)',
	linkDescriptionPlaceholder: 'Legg til en beskrivelse',
	linkUri: 'URL',
	linkUriPlaceholder: 'Legg til en URL med et godkjent domene',
	acceptableDomains: 'Godkjente domener',
	viewAcceptableDomains: 'Vis godkjente domener',
	mandatoryField: 'Obligatorisk felt',
	linkAdded: 'URL lagt til',
	toastCreateNewLink: '%{nameOfLink} ble lagt til i %{tabName}.',
	noEntries: 'Det er ingen oppføringer på listen over godkjente domener. Ta kontakt med administratoren.',
	unacceptableDomain: 'URLen bruker et ugyldig domene. Klikk på \'Vis godkjente domener\' for å få se en liste over domener du kan bruke.',

	compact: 'Komprimert',
	short: 'Kort',
	default: 'Standard',
	rowSize: 'Radstørrelse',

	// GroupyByTypes
	folders: 'Mapper',
	reports: 'Rapporter',
	dashboards: 'Dashbord',
	data: 'Data',
	packages: 'Pakker',
	explorations: 'Utforskinger',
	stories: 'Historie',
	notebooks: 'Notisbøker',
	others: 'Annet',

	// Error Messages
	itemsOverLimit: 'Det oppgitte navnet "%{itemName}" har overskredet maksimumsgrensen (20). Oppgi et annet navn for å fortsette.',
	errorMessageLengthFolderName: 'Oppgi et mappenavn som ikke overskrider 255 tegn.',
	errorMessageLengthLinkName: 'Oppgi et linknavn som ikke overskrider 255 tegn.',
	toastLaunchPerspectiveError: 'Kan ikke åpne %{objectType}.',
	errorNoAccessTitle: 'Hmm, det ser ut som du har ikke tilgang til dette innholdet',
	errorNoAccessBody: 'Kontakt administratoren eller gå til følgende link:',
	errorEnableExternalContent: 'Aktivere eksternt innhold',

	//TableHeader
	lastAccessed: 'Siste tilgang',
	location: 'Plassering',
	tenant: 'Leietaker',

	// GetStartedTab
	getStartedLabel: 'Kom i gang med IBM Cognos Analytics',
	learningHowToLabel: 'Opplæringsressurser',
	learningHowToDescription: 'Utvid kunnskapen din og få hjelp ved å delta i fellesskapet, lese dokumentasjon og se på videoer.',
	learningHowToActionLabel: 'Åpne opplæringsruten',
	howToVideosLabel: 'Opplæringsvideoer',
	howToVideosDescription: 'Lær hvordan du bruker IBM Cognos Analytics, og få mer innsikt i dataene dine.',
	howToVideosActionLabel: 'Se videoer',
	acceleratorCatalogLabel: 'Accelerator-katalog',
	acceleratorCatalogDescription: 'Bla gjennom en stadig økende katalog med bransjeeksempler, veiledere om beste praksis, tilpassede visualiseringer og mer.',
	acceleratorCatalogActionLabel: 'Bla gjennom katalog',
	sampleSectionTitle: 'Eksempler',
	sampleSectionDescription: 'Eksperimenter med eksempler som viser alt Cognos Analytics har å tilby.',
	// Samples Section
	createDashboardSampleTitle: 'Hvordan opprette ditt første dashbord',
	createDashboardSampleDescription: 'Start analysereisen din med Cognos-dashbord.',
	nlaSampleTitle: 'Eksempelrapport',
	nlaSampleDescription: 'Utforsk hva som er mulig med Cognos Analytics -rapporter med dette eksemplet som analyserer aktivitet ved årsslutt for lojalitetskortmedlemmer.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Utvid visualiseringsbiblioteket med tilpassede visualiseringer som Sankey-diagrammet.',
	viewAllSamplesActionLabel: 'Vis alle eksempler',
	byFeatureTitle: 'Etter funksjon',
	byFeatureDescription: 'Bla gjennom Eksempler basert på funksjon, for eksempel kjernefunksjonalitet, tilpassede kontroller, utvidelser, notatbøker og relative datoer.',
	byIndustryTitle: 'Etter bransje',
	byIndustryDescription: 'Bla gjennom eksempler basert på bransje, for eksempel bil, bank og så videre.',
	// SamplesTab
	sampleTabTitle: 'Bli inspirert med våre forhåndsbygde eksempler',
	sampleTabLabel: 'Besøk Accelerator Catalog for å få flere eksempler og utvidelser fra IBM, partnere og kunder',

	// quickLaunch
	quickLaunchLabel: 'Hurtigstart',
	expand: 'Utvid',
	collapse: 'Komprimer',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Begynn med å velge hva du vil opprette.',

	// contentPageView
	contentPageTitleLabel: 'Innhold',
	uploadFile: 'Last opp data',
	new: 'Ny',
	create: 'Opprett',
	more: 'Mer',

	// open dialog
	selectDataSourcesToAdd: 'Velg datakilde(r) som skal legges til.',
	openDialogDefaultTitle: 'Åpne',

	// save dialog
	save: 'Lagre',
	saveAs: 'Lagre som',
	saving: 'Lagrer...',
	selectedDestination: 'Valgt mål: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' finnes allerede med en annen type. Velg et annet navn.',
	confirmOverwriteTitle: 'Bekreft erstatning av eksisterende data',
	confirmOverwriteMsg: 'Filen \'%{nameOfFile}\' finnes allerede. Vil du erstatte dataene der med dataene fra den valgte filen?',

	// copy move dialog
	copy: 'Kopier',
	move: 'Flytt',
	copyOrMove: 'Kopier eller flytt: ',
	copyOnly: 'Kopier ',
	createShortcut: 'Opprett snarvei',
	createShortcutDialogTitle: 'Opprett snarvei: ',

	// External asset types
	wsProject: 'Watson Studio-prosjekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pakke',
	dataModule: 'Datamodul',
	exploration: 'Utforsking',
	mode: 'Modus',
	live: 'Aktiv',
	snapshot: 'Snapshot',
	noSnapshotsFound: 'Fant ingen snapshot',
	uploadedFile: 'Opplastet fil',
	fileUpload: 'Last opp data',
	dataSetEx: 'Datasett',
	externalRepository: 'Eksternt datalager',
	queryMode: 'Spørringsmodus',
	queryModeCompatible: 'Kompatibel',
	queryModeDynamic: 'Dynamisk',
	report: 'Rapport',
	activeReport: 'Active Report',
	query: 'Spørring',
	analysis: 'Analyse',
	dashboard: 'Dashbord',
	dashboardTemplate: 'Dashbordmal',
	jupyterNotebook: 'Notisbok',
	wsNotebook: 'Watson Studio-notisbok',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Historie',
	workspace: 'Arbeidsområde',
	pagelet: 'Side',
	content: 'Innhold',
	directory: 'Navneområder',
	dataSet: 'Datasett',
	powerPlayCube: 'PowerPlay Cube',
	powerPlayReport: 'PowerPlay-rapport',
	powerPlay8Report: 'PowerPlay-rapport',
	setPowerPlay8ReportOptions: 'Definer PowerPlay-rapportalternativer',
	powerPlay8ReportView: 'PowerPlay-rapportvisning',
	reportTemplate: 'Rapportmal',
	packageConfigurations: 'Pakkekonfigurasjon',
	agent: 'Agent',
	agentDefinition: 'Agentdefinisjon',
	agentDefinitionView: 'Agentvisning',
	dataMovementTask: 'Dataflyttingsoppgave',
	dataMovementTaskAlias: 'Alias for dataflyttingsoppgave',
	document: 'Dokument',
	DocumentRetention: 'Dokumentegenskaper',
	jobDefinition: 'Jobbdefinisjon',
	job: 'Jobb',
	jobs: 'Jobber',
	metricsDataSourceETLTask: 'ETL-oppgave for datakilde for styringsparametere',
	metricsExportTask: 'Eksportoppgave for styringsparametere',
	metricsFileImportTask: 'Filimportoppgave for styringsparametere',
	metricsMaintenanceTask: 'Vedlikeholdsoppgave for styringsparametere',
	planningTask: 'Planleggingsoppgave',
	shortcut: 'Snarvei',
	shortcuts: 'Snarveier',
	URL: 'URL',
	launchable: 'Kan startes',
	dataSetFolder: 'Datasettmappe',
	ViewAccessibleLabel: 'Vis %{label}',
	overrideReportOptions: 'Overstyre standard rapportalternativer',
	formats: 'Formater',
	saveReport: 'Lagre rapporten',
	reportView: 'Rapportvisning',
	reportviews: 'Rapportvisninger',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-data',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rolle',
	namespace: 'Navneområde',
	namespaceFolder: 'Navneområdemappe',
	adminFolder: 'Admin-mappe',
	//Details
	details: 'Detaljer',
	open: 'Åpne',
	created: 'Opprettet',
	modified: 'Endret',
	owner: 'Eier',
	dataSource: 'Datakilde',
	share: 'Del',
	addToFavorites: 'Legg til i favoritter',
	properties: 'Egenskaper',
	detailsEmptyStateBody: 'Velg et element for å vise detaljene',
	editNameAndDescription: 'Rediger navn og beskrivelse',
	none: 'Ingen',
	setPdfOptions: 'Definer PDF-alternativer',
	runOptions: 'Kjørevalg',

	//rename dialog
	nameInvalid: 'Navnet er ugyldig',
	namePlaceholder: 'Oppgi et navn',
	description: 'Beskrivelse',
	descriptionInvalid: 'Beskrivelsen kan ikke overskride 350 tegn.',
	descriptionPlaceholder: 'Oppgi en beskrivelse',
	errorMessageApostropheError: 'Oppgi et filnavn som ikke inneholder både tegnet \' og tegnet "',
	renameCollisionError: '%{name} finnes allerede. Prøv et annet navn.',
	unknownRenameError: 'Endring av elementnavn mislyktes. Kontakt administratoren for å få mer hjelp.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Kan ikke åpne den oppgitte mappen.',

	//Upload
	uploadToFolder: "Last opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Last opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> og start %{launchAction}",
	quickUpload: "Hurtigopplasting",
	quickUploadAndLaunch: "Dra og slipp filer for å laste opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> og åpne i et av følgende områder.",
	unsupportedFilesSingle: "%{files} ble ikke lastet opp fordi den er ugyldig for Hurtigstart.",
	unsupportedFilesMultiple: "Filene ble ikke lastet opp fordi alle filene du velger, må være gyldige for å bruke Hurtigstart.",
	unsupportedFilesSingleInvalid: "%{files} er ugyldig.",
	unsupportedFilesMultipleInvalid: "%{files} er ugyldige.",
	supportedFileTypes: "Bare følgende filtyper er tillatt: %{extensions}.",
	uploadDragAndDrop: "Dra og slipp",
	uploadDragAndDropMessage: "Dra og slipp filen din her for å laste den opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Søkekriteriene \'%{searchTerm}\' ble lagret.',
	searchWasntSaved: 'Søkekriteriene \'%{searchTerm}\' ble ikke lagret.',
	searchSuggestions: 'Forslag',
	savedSearch: 'Lagrede søk',
	searchWasDeleted: 'Søkekriteriene \'%{searchTerm}\' ble slettet.',
	searchWasntDeleted: 'Søkekriteriene \'%{searchTerm}\' ble ikke slettet.',
	savedBarTitle: 'Søk i Cognos Analytics',
	searchContentPageTitle: 'Søk',
	searchContentPageTitleLabel: 'Viser resultater for \'%{searchTerm}\'',
	showingSearchRsult: 'Viser %{resultCount} elementer',
	saveSearch: 'Lagre søk',
	saveTenSearches: 'Du kan lagre 10 søk.',
	deleteASearch: 'Slett ett for å lagre et annet.',
	close: 'Lukk',
	allContent: 'Alt innhold',
	searchResultIn: 'Søkeresultat i: ',
	//recent view
	recents: 'Nyeste',
	noAccessRecent: 'Ingen tilgang',
	noAccessRecentMsg: 'Du har ikke tilgang til denne ressursen. Den kan ha blitt deaktivert eller slettet, eller tillatelsene dine kan ha blitt redusert. Kontroller statusen for ressursen på den forventede kildeplasseringen. Du kan fjerne ressursen fra de nyeste elementene ved å klikke på OK.',
	noAccessMsg: 'Du har ikke tilgang til denne ressursen. Den kan ha blitt deaktivert eller slettet, eller tillatelsene dine kan ha blitt redusert.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elementer valgt',
	itemSelected: '%{nameOfSelection} element valgt',

	//properties
	general: 'Generelt',
	schedule: 'Plan',
	permission: 'Tillatelser',
	capabilities: 'Egenskaper',
	propertiesTabsLabel: 'Innhold i egenskaper',
	searchPath: 'Søkebane',
	id: 'ID',
	language: 'Språk',
	setLanguage: 'Definer språk',
	entryOptions: 'Oppføringsalternativer',
	setPackage: 'Definer pakke eller modul',
	sourcePackage: 'Kildepakke eller datamodul',
	associatedSourceAgent: 'Kildepakke',
	setAssociatedSourceAgent: 'Definer pakke',
	sourceAgent: 'Kildeagent',
	setSourceAgent: 'Definer kildeagent',
	setCapabilities: 'Angi egenskaper',
	disableEntry: 'Deaktiver denne oppføringen',
	hideEntry: 'Skjul denne oppføringen',
	permissions: 'Tillatelser',
	promptForValues: 'Spør om verdier',
	yes: 'Ja',
	no: 'Nei',
	setValues: 'Definer verdier',
	moreOptions: 'Flere alternativer',
	reportFormat: 'Rapportformat',
	enableAccessibilitySupport: 'Aktiver tilgjengelighetstøtte',
	displayOfRunHistory: 'Visning av kjørehistorikk',
	occurrences: 'Forekomster',
	days: 'Dag(er)',
	months: 'Måned(er)',
	displayOfReportOutputVersions: 'Visning av rapportutdataversjon',
	defaultDisplayOfPortalAction: 'Standard portalhandling',
	viewMostRecentReport: 'Vis den nyeste rapporten',
	runTheReport: 'Kjør rapporten',
	openWithReportStudio: 'Åpne med Report Studio',
	rowsPerPageInHtmlReports: 'Rader per side i HTML-rapporter',
	enableSelectionBasedInteractivity: 'Aktiver valgbasert interaktivitet',
	enableAlertsAboutNewVersions: 'Aktiver varsler om nye versjoner',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Aktiver utvidede brukerfunksjoner i lagrede utdataversjoner',
	enableCommentsInSavedOutputVersions: 'Aktiver kommentarer i lagrede utdataversjoner',
	run: 'Kjør',
	runWithUsersCredentials: 'Med brukerens legitimasjon',
	runWithOwnerCapabilities: 'Med eieregenskaper',
	runAsOwner: 'Som %{ownerName}',
	actionLabelOn: 'På',
	actionLabelOff: 'Av',
	openReport: 'Rediger',
	openAnalysis: 'Åpne med Analysis Studio',
	openQuery: 'Åpne med Query Studio',
	openPowerPlay8Report: 'Åpne med PowerPlay Studio',
	openInteractiveReport: 'Rediger',
	read: 'Les',
	write: 'Skriv',
	execute: 'Utfør',
	setPolicy: 'Definer policy',
	full: 'Fullstendig',
	traverse: 'Traverser',
	grant: 'Gi',
	deny: 'Avvis',
	permissionCustom: 'Tilpasset',
	permissionDetailsColumnAccess: 'Tilgang',
	permissionDetailsColumnPermission: 'Tillatelse',
	permissionDetailsColumnAction: 'Handling',
	permissionSetAccess: 'Definer tilgang',
	permissionRead: 'Les',
	permissionRun: 'Kjør',
	permissionWrite: 'Skriv',
	permissionFull: 'Fullstendig',
	unavailable: 'Ikke tilgjengelig',
	unkownSource: 'Ukjent, åpne rapport for detaljer',
	tenantSettings: 'Innstillinger for leietaker',
	tenantSet: 'Leietaker oppdatert',
	tenantSetError: 'Feil ved definering av leietaker',
	tenantClear: 'Leietaker fjernet',
	tenantClearError: 'Feil ved fjerning av leietaker',
	shortcutTo: 'Snarvei til',
	sourceReport: 'Kilderapport',
	setSourceReport: 'Definer kilderapport',
	setSourceLocation: 'Definer kilde %{itemName} sin plassering',
	linkPackageOrModule: 'Link %{itemName} til en pakke eller datamodul',
	linkPackage: 'Link %{itemName} til en pakke',
	externalRepositories: 'Eksterne datalagre',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} kB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Oppdateringstid',
	size: 'Størrelse',
	tenantsWarningMessage: 'Hvis du endrer leietakeren for en oppføring, endres også leietakeren for underordnede oppføringer.',
	confirmClearTenantText: 'Hvis verdien endres til \'Ingen\', kan kanskje andre leietakere få tilgang til innholdet. Klikk på OK for å gjøre oppføringen felles, eller klikk på Avbryt for å beholde gjeldende leietaker.',
	confirmClearTenant: 'Bekreft fjerning av leietaker',
	currentValues: 'Gjeldende verdier',
	emptyPromptValues: 'Det finnes foreløpig ingen verdier',
	editValues: 'Rediger verdier',
	clear: 'Fjern',
	source: 'Kilde',
	dataRefreshed: 'Data oppdatert',
	//PDF options
	pdfOptions: 'PDF-alternativer',
	set: 'Sett',
	portrait: 'Stående',
	landscape: 'Liggende',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Retning',
	pageDefination: 'Papirstørrelse',
	openPasswordRequired: 'Krev passord for å åpne rapport',
	accessPasswordRequired: 'Krev passord for tilgang til rapport',
	emptyPassword: 'Passord kan ikke være tomt',
	password: 'Passord',
	enterPassword: 'Skriv inn passord',
	confirmPassword: 'Bekreft passord',
	passwordMatchError: 'Passordene er ikke like',
	gateway: 'Gateway',
	pageLayout: 'Sidelayout',
	pageStyle: 'Stil',
	setUrl: 'Definer URL',
	numberRows: 'Antall rader',
	numberColumns: 'Antall kolonner',
	timeToRefresh: 'Oppdateringstid',
	lastRefreshedBy: 'Oppdatert av',
	unknown: 'Ukjent',
	unknownUpdateError: 'Oppdatering av element mislyktes. Kontakt administratoren for å få mer hjelp.',
	editQuery: 'Rediger spørring',
	greaterOrEqual: 'Større enn eller lik %{upperboundValue}',
	lessOrEqual: 'Mindre enn eller lik %{lowerboundValue}'
});
